/**
 * A binary pattern that describes the standard octant layout:
 *
 * ```text
 *    3____7
 *  2/___6/|
 *  | 1__|_5
 *  0/___4/
 * ```
 *
 * This common layout is crucial for positional assumptions.
 */

export const layout = [

    new Uint8Array([0, 0, 0]),
    new Uint8Array([0, 0, 1]),
    new Uint8Array([0, 1, 0]),
    new Uint8Array([0, 1, 1]),

    new Uint8Array([1, 0, 0]),
    new Uint8Array([1, 0, 1]),
    new Uint8Array([1, 1, 0]),
    new Uint8Array([1, 1, 1])

];